import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceSetupListActions from '../actions/ecommerce-setup-list.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {LoadEcommerceSetupList} from "../actions";


@Injectable()
export class EcommerceSetupEffect {

  loadEcommerceSetup$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceSetupListActions.LOAD_ECOMMERCE_SETUP_LIST),
    mergeMap((action: LoadEcommerceSetupList) => {
      const {websiteId} = action.payload;
      return this._ecommerceService.getEcommerceSetupListData(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceSetupListActions.LoadEcommerceSetupListSuccess(response.data);
            }
            return new EcommerceSetupListActions.LoadEcommerceSetupListFails(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService
  ) {
  }

}
